import Translations from "translations/types";

export const SEARCH_MERGE_AUCTION_NOT_STARTED_KEY =
  "search_merge_not_started" as const;

const SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS = {
  CONTACT_PROVIDERS: "contact_providers",
  PATIENT_WISH: "patient_wish",
  SEARCH_TAB: "search_tab",
  TABLE_ROW: "table_row",
} as const;

export const SEARCH_MERGE_AUCTION_NOT_STARTED = {
  disablePageScroll: true,
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  key: SEARCH_MERGE_AUCTION_NOT_STARTED_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.CONTACT_PROVIDERS]: {
      intro: (t: Translations) => t.tours.searchMerge.stepB.intro,
      key: SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.CONTACT_PROVIDERS,
      step: 2,
      title: (t: Translations) => t.tours.searchMerge.stepB.title,
    },
    [SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.PATIENT_WISH]: {
      intro: (t: Translations) => t.tours.searchMerge.stepC.intro,
      key: SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.PATIENT_WISH,
      step: 3,
      title: (t: Translations) => t.tours.searchMerge.stepC.title,
    },
    [SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.SEARCH_TAB]: {
      intro: (t: Translations) => t.tours.searchMerge.stepA.intro,
      key: SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.SEARCH_TAB,
      step: 1,
      title: (t: Translations) => t.tours.searchMerge.stepA.title,
    },
    [SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.TABLE_ROW]: {
      intro: (t: Translations) => t.tours.searchMerge.stepD.intro,
      key: SEARCH_MERGE_AUCTION_NOT_STARTED_STEPS.TABLE_ROW,
      step: 4,
      title: (t: Translations) => t.tours.searchMerge.stepD.title,
    },
  },
} as const;
